import { action } from 'typesafe-actions';
export const getModalActions = () => ({
    openModal: function (name, metadata = null) {
        return action(OPEN_MODAL, { name, metadata });
    },
    closeModal: function (name) {
        return action(CLOSE_MODAL, { name });
    },
    toggleModal: function (name) {
        return action(TOGGLE_MODAL, { name });
    }
});
const { openModal, closeModal, toggleModal } = getModalActions();
// Open Modal
export const OPEN_MODAL = 'Open modal';
export { openModal };
// Close Modal
export const CLOSE_MODAL = 'Close modal';
export { closeModal };
// Toggle Modal
export const TOGGLE_MODAL = 'Toggle modal';
export { toggleModal };
// Close All Modals
export const CLOSE_ALL_MODALS = 'Close all modals';
export const closeAllModals = () => action(CLOSE_ALL_MODALS, {});
//# sourceMappingURL=actions.js.map